import type { AdminSettings } from '../types/admin'
import { loadState, saveState } from './storage'

/**
 * GLOBALE INDSTILLINGER
 * ---------------------
 * Sæt SETTINGS_ENDPOINT til adressen på din backend, fx:
 *
 *   export const SETTINGS_ENDPOINT = 'https://din-server.dk/api/settings'
 *
 * Endpointet skal understøtte:
 *   GET  → returnerer indstillingerne som JSON
 *   PUT  → modtager indstillingerne som JSON og gemmer dem
 *
 * Når adressen er sat, hentes og gemmes firmaoplysningerne på serveren, så
 * ALLE besøgende — i alle browsere og på alle enheder — ser de samme data.
 * Så længe feltet er tomt, gemmes indstillingerne kun i denne browser.
 */
export const SETTINGS_ENDPOINT = ''

export const hasGlobalStorage = Boolean(SETTINGS_ENDPOINT)

/** Lokal kopi, så siden kan vise de senest kendte data med det samme. */
export function readCachedSettings(fallback: AdminSettings): AdminSettings {
  return { ...fallback, ...loadState<Partial<AdminSettings>>('settings', {}) }
}

export function cacheSettings(settings: AdminSettings): boolean {
  return saveState('settings', settings)
}

export async function fetchGlobalSettings(): Promise<AdminSettings | null> {
  if (!SETTINGS_ENDPOINT) return null
  const response = await fetch(SETTINGS_ENDPOINT, { headers: { Accept: 'application/json' } })
  if (!response.ok) throw new Error(`Serveren svarede ${response.status}`)
  return (await response.json()) as AdminSettings
}

export async function saveGlobalSettings(settings: AdminSettings): Promise<void> {
  if (!SETTINGS_ENDPOINT) return
  const response = await fetch(SETTINGS_ENDPOINT, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  })
  if (!response.ok) throw new Error(`Serveren svarede ${response.status}`)
}
